import { render, staticRenderFns } from "./ImageBox.vue?vue&type=template&id=25948bbc&scoped=true"
import script from "./ImageBox.vue?vue&type=script&lang=js"
export * from "./ImageBox.vue?vue&type=script&lang=js"
import style0 from "./ImageBox.vue?vue&type=style&index=0&id=25948bbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25948bbc",
  null
  
)

export default component.exports